module.exports = __webpack_public_path__ + "static/media/purple_circle.8e4b1353.png";